"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareSection = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.get"));
var _Sanitizer = require("../../base-components/Sanitizer/Sanitizer");
var _Link = require("../../base-components/Link/Link");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var findCardFeature = function findCardFeature(card, identifier) {
  var cardFeatures = card.cardFeatures || {};
  var cardFeaturesContent = cardFeatures.content || [];
  var currentFeature = cardFeaturesContent.find(function (cardFeature) {
    return cardFeature.key === identifier;
  });
  return currentFeature;
};
var handleTextFeature = function handleTextFeature(textFeature) {
  return /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    safelySetInnerHTML: textFeature.text,
    Component: 'p',
    className: "text"
  });
};
var handleListFeature = function handleListFeature(listFeature) {
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list"
  }, listFeature.content.map(function (feature, index) {
    var key = "list-item-".concat(index);
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: key
    }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
      safelySetInnerHTML: feature.text,
      Component: 'p',
      className: "listText"
    }));
  }));
};
var renderCardFeature = function renderCardFeature(cardFeature) {
  var feature = (0, _lodash["default"])(cardFeature, 'desc[0]', {});
  var renderedFeature;
  if (feature.type === 'LIST') {
    renderedFeature = handleListFeature(feature);
  } else {
    renderedFeature = handleTextFeature(feature);
  }
  var links = (0, _lodash["default"])(cardFeature, 'links') || [];
  renderedFeature = [renderedFeature].concat(_toConsumableArray(links.map(function (link) {
    return /*#__PURE__*/_react["default"].createElement(_Link.Link, {
      to: link.url,
      className: "section-link",
      namespace: "compare-section/section-link"
    }, link.title);
  })));
  return renderedFeature;
};
var CompareSection = exports.CompareSection = function CompareSection(_ref) {
  var identifier = _ref.identifier,
    maxNumOfCards = _ref.maxNumOfCards,
    title = _ref.title,
    activeCards = _ref.activeCards;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "compare-section"
  }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
    safelySetInnerHTML: title,
    Component: "h2",
    className: "compare-section__title"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "compare-section__content"
  }, _toConsumableArray(Array(maxNumOfCards).keys()).map(function (index) {
    var card = activeCards[index];
    if (card) {
      var currentFeature = findCardFeature(card, identifier);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('compareContent', "".concat(card.shortName, "-content")),
        key: index
      }, renderCardFeature(currentFeature));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "compareContent compareContent--no-card",
      key: index
    });
  })));
};
CompareSection.propTypes = {
  identifier: _propTypes["default"].string.isRequired,
  maxNumOfCards: _propTypes["default"].number.isRequired,
  title: _propTypes["default"].string.isRequired,
  activeCards: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired
};